import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import App from "./App.vue"
import DashboardPage from "./pages/DashboardPage.vue"
import PartnersPage from "./pages/PartnersPage.vue"
import TasksPage from "./pages/TasksPage.vue"
import ReportsPage from "./pages/ReportsPage.vue"
import ImportsPage from "./pages/ImportsPage.vue"
import SettingsPage from "./pages/SettingsPage.vue"
import ChatsPage from "./pages/ChatsPage.vue"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/dashboard" },
    { path: "/dashboard", component: DashboardPage },
    { path: "/partners/:id?", component: PartnersPage },
    { path: "/tasks/:id?", component: TasksPage },
    { path: "/reports", component: ReportsPage },
    { path: "/imports", component: ImportsPage },
    { path: "/chats/:id?", component: ChatsPage },
    { path: "/settings/:section?", component: SettingsPage }
  ]
})

createApp(App).use(router).mount("#app")
